module.exports = __webpack_public_path__ + "img/project4.e37aa5fd.jpg";